import { Badge } from "@/components/ui/badge"

// Color the funnel stage on a cool→warm→success spectrum so lists and
// the per-prospect view scan visually: dim zinc for "no signal yet"
// through emerald for "report is ready in their hands." Shared by the
// Prospects index and the per-prospect ProspectShow view so the badge
// can't drift between them.
export const STAGE_STYLES = {
  sent:      "bg-zinc-100 text-zinc-700 border-zinc-200",
  clicked:   "bg-blue-100 text-blue-800 border-blue-200",
  started:   "bg-indigo-100 text-indigo-800 border-indigo-200",
  submitted: "bg-amber-100 text-amber-800 border-amber-200",
  generated: "bg-emerald-100 text-emerald-800 border-emerald-200",
}

export function FunnelStageBadge({ stage, label }) {
  const className = STAGE_STYLES[stage] || STAGE_STYLES.sent
  return (
    <Badge variant="outline" className={`text-xs font-medium ${className}`}>
      {label}
    </Badge>
  )
}
